import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 13\" id=\"icon-chevron-left\"><path d=\"M6.5 13L0 6.7 6.6 0 8 1.3 2.8 6.7l5.1 4.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol